import React from 'react';
import { Group, Text } from '@mantine/core';
import { EventIcon } from '@dealstack/frontend/app/pages/Project/Cap/CapTablePage/common/EventIcon.tsx';
import { CopyCellText as CopyText } from '@dealstack/frontend/app/pages/Project/Cap/CapTablePage/common/CopyCellText';
import { HoldingEventType } from '@dealstack/shared/lib/generated';
import { NumericText } from '@dealstack/frontend/shared/components/Table/MantineTable/Cells/NumericCell';

interface Props {
	hasAssignment: boolean;
	hasPledge: boolean;
	value: string | number;
	copyable?: boolean;
	numeric?: boolean;
	buildHoldingsLink?: () => string;
}

export const TableCellWithEvents = ({
	hasAssignment,
	hasPledge,
	value,
	copyable = false,
	numeric = false,
	buildHoldingsLink,
}: Props) => {
	const renderValue = () => {
		if (copyable) {
			return <CopyText text={value}>{value}</CopyText>;
		}

		if (numeric) {
			return <NumericText value={String(value)} />;
		}

		return <Text size="B6Medium">{value}</Text>;
	};

	return (
		<Group justify={numeric ? 'flex-end' : 'flex-start'} gap="xs" wrap="nowrap" w="100%">
			{hasAssignment && (
				<EventIcon
					type={HoldingEventType.ASSIGNMENT_OF_VOTING_RIGHTS}
					size="vlg"
					{...(buildHoldingsLink && { linkTo: buildHoldingsLink() })}
				/>
			)}
			{hasPledge && (
				<EventIcon
					type={HoldingEventType.PLEDGING_OF_SHARES}
					size="vlg"
					{...(buildHoldingsLink && { linkTo: buildHoldingsLink() })}
				/>
			)}
			{renderValue()}
		</Group>
	);
};
